import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FilmGrain from "@/components/FilmGrain";

// Live site shell.
const SiteShell = ({ children }) => {
  return (
    <>
      <FilmGrain />
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  );
};

export default SiteShell;
